import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FileDown, Box, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api, asset, money, applyTheme, BACKEND, TaxLines } from "@/lib/api";
import { SiteHeader } from "@/components/Brand";
import { LeadCTA, BrandButton } from "@/components/LeadForms";

export default function SavedHome() {
  const { sid } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/public/selections/${sid}`).then((r) => { setD(r.data); applyTheme(r.data.builder); });
  }, [sid]);
  if (!d) return <div className="min-h-screen" />;
  const { selection: s, house_type: h, plot, development: dev, builder } = d;
  const share = () => { navigator.clipboard?.writeText(window.location.href); toast.success("Link copied"); };
  return (
    <div className="min-h-screen pb-24">
      <SiteHeader builder={builder} right={<LeadCTA builderId={builder.id} context={{ house_type_id: h.id, plot_id: plot?.id }} className="hidden md:flex" />} />
      <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-12">
        <p className="text-xs uppercase tracking-[0.3em] text-ba">Saved home · {s.name}</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-semibold mt-3" data-testid="saved-home-title">{h.name}</h1>
        <p className="text-slate-600 mt-2">{[plot && `Lot ${plot.plot_number}`, dev?.name].filter(Boolean).join(" · ")}</p>
        <img src={asset(h.photos?.[0])} alt="" className="mt-8 w-full aspect-[21/9] object-cover rounded-3xl" />
        <div className="grid md:grid-cols-[1fr_320px] gap-8 mt-10">
          <div className="space-y-3" data-testid="saved-home-items">
            {s.items.map((i) => (
              <div key={i.category_id} className="flex items-center gap-4 p-4 rounded-2xl bg-white border">
                {i.image_url ? <img src={asset(i.image_url)} alt="" className="w-14 h-14 rounded-xl object-cover" /> : <span className="w-14 h-14 rounded-xl border" style={{ background: i.swatch }} />}
                <div className="flex-1"><p className="text-xs uppercase tracking-widest text-slate-500">{i.category}</p><p className="font-medium">{i.option}</p></div>
                <span className="text-sm">{i.is_upgrade ? `+${money(i.price)}` : "Included"}</span>
              </div>
            ))}
          </div>
          <div className="rounded-3xl bg-white border p-6 h-fit">
            <div className="flex justify-between text-sm"><span>Base price</span><span>{money(s.base_price)}</span></div>
            <div className="flex justify-between text-sm mt-2"><span>Upgrades</span><span>{money(s.upgrades_total)}</span></div>
            <TaxLines builder={builder} total={s.total} className="mt-4 pt-4 border-t" />
            <div className="grid gap-2 mt-6">
              <a href={`${BACKEND}/api/public/selections/${s.id}/pdf`} target="_blank" rel="noreferrer" data-testid="saved-home-pdf"><BrandButton className="w-full"><FileDown className="w-4 h-4" />Download PDF quote</BrandButton></a>
              <Link to={`/view/${h.id}?${plot ? `plot=${plot.id}&` : ""}sel=${s.id}`} data-testid="saved-home-tour"><BrandButton variant="ghost" className="w-full"><Box className="w-4 h-4" />Open in 3D</BrandButton></Link>
              <BrandButton variant="ghost" onClick={share} data-testid="saved-home-share"><Share2 className="w-4 h-4" />Copy share link</BrandButton>
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden fixed bottom-0 inset-x-0 p-3 glass z-30"><LeadCTA builderId={builder.id} context={{ house_type_id: h.id, plot_id: plot?.id }} className="justify-center" /></div>
    </div>
  );
}
